module.exports = "<p>monitored-train-canvas works!</p>\n";